import { RefObject, useEffect } from "react";
import { useMotionValue } from "framer-motion";

/**
 * 0 → 1 progress through a tall pinned section. Measures the element every
 * frame, so it works whichever element is the page's scroll container.
 */
export function useSectionProgress(ref: RefObject<HTMLElement>) {
  const progress = useMotionValue(0);

  useEffect(() => {
    let raf = 0;
    const loop = () => {
      const el = ref.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const travel = rect.height - window.innerHeight;
        const p = travel > 0 ? Math.min(1, Math.max(0, -rect.top / travel)) : 0;
        if (Math.abs(p - progress.get()) > 0.0005) progress.set(p);
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [ref, progress]);

  return progress;
}
